// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hAg6cDD2{position:relative;width:100%}.xr3jnYYj{position:absolute;top:100%;left:0;right:0}`, "",{"version":3,"sources":["webpack://./src/client/common/listSelect/styles.scss"],"names":[],"mappings":"AAAA,UACE,iBAAA,CACA,UAAA,CAGF,UACE,iBAAA,CACA,QAAA,CACA,MAAA,CACA,OAAA","sourcesContent":[".input {\n  position: relative;\n  width: 100%;\n}\n\n.list {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input": `hAg6cDD2`,
	"list": `xr3jnYYj`
};
export default ___CSS_LOADER_EXPORT___;
